import { render, staticRenderFns } from "./PackageOffer.vue?vue&type=template&id=26dc05bf&scoped=true&"
import script from "./PackageOffer.vue?vue&type=script&lang=js&"
export * from "./PackageOffer.vue?vue&type=script&lang=js&"
import style0 from "./PackageOffer.vue?vue&type=style&index=0&id=26dc05bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26dc05bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26dc05bf')) {
      api.createRecord('26dc05bf', component.options)
    } else {
      api.reload('26dc05bf', component.options)
    }
    module.hot.accept("./PackageOffer.vue?vue&type=template&id=26dc05bf&scoped=true&", function () {
      api.rerender('26dc05bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/PackageOffer.vue"
export default component.exports